// https://github.com/oblador/react-native-vector-icons?tab=readme-ov-file#web-setup
import iconFontRegular from 'react-native-vector-icons/Fonts/FontAwesome6_Regular.ttf';
import iconFontSolid from 'react-native-vector-icons/Fonts/FontAwesome6_Solid.ttf';

export const bootstrapReactNativeVectorIcons = () => {
  const iconFontStyles = `
    @font-face {
      src: url(${iconFontRegular});
      font-family: FontAwesome6_Regular;
    }
    @font-face {
      src: url(${iconFontSolid});
      font-family: FontAwesome6_Solid;
    }
  `;

  // Create a stylesheet
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const style: any = document.createElement('style');
  style.type = 'text/css';

  // Append the iconFontStyles to the stylesheet
  if (style?.styleSheet) {
    style.styleSheet.cssText = iconFontStyles;
  } else {
    style.appendChild(document.createTextNode(iconFontStyles));
  }

  // Inject the stylesheet into the document head
  document.head.appendChild<Node>(style);
};
